//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageModal from "@/components/objects/ImageModal.vue";
import IconView from "@/components/objects/IconView.vue";
import { BUILD_STORAGE_IMAGE_PATH } from "@/constants/ui.js";
import { adjustColorBrightness, buildMaskStyle } from "@/utils/helpers.js";
import TheMaskIcon from '@/components/objects/TheMaskIcon.vue';

export default {
  name: "DefaultImage",
  components: { IconView, TheMaskIcon },
  props: {
    item: {
      type: Object,
      default: () => {
        return {
          id: "",
          label: "",
          text: ""
        }
      }
    },
    objectId: {
      type: String
    },
    iconBorderColor: {
      type: String
    },
    blockBorderColor: {
      type: String,
    },
    bgColor: {
      type: String
    },
    bgGradientEnabled: {
      type: Boolean,
    },
    bgGradientDirection: {
      type: String,
      default: 'bottom'
    },
    bgGradientShadowDirection: {
      type: String,
      default: 'transparent'
    },
    iconBgColor: {
      type: String
    },
    iconColor: {
      type: String
    },
    mask: {
      type: String
    },
    textColor: {
      type: [String, null],
      default: null
    },
    detail: {
      type: Boolean,
      default: false
    },
    openId: {
      type: String
    },
    useStorage: {
      type: Boolean,
    }
  },
  data() {
    return {
      textClamp: true,
      isOpen: false
    }
  },
  computed: {
    manuallyOpen() {
      return this.item.id === this.openId
    },
    showExpandBtn() {
      return (this.manuallyOpen || this.textClamp) && !this.detail
    },
    highlight() {
      return this.$route.hash === `#${this.item.id}`
    },
    currentText() {
      return this.manuallyOpen || this.detail ? this.item.fullText : this.item.shortText
    },
    imagePath() {
      if (this.useStorage) {
        return BUILD_STORAGE_IMAGE_PATH(this.item.image_file)
      } else {
        return `/public/object_attrs_files/${this.objectId}/${this.item.id}/`
      }
    },
    getBg() {
      if (this.bgGradientEnabled) {
        return `linear-gradient(to ${this.bgGradientDirection}, ${this.bgGradientShadowDirection === 'transparent' ? `${this.bgColor ?? this.color}, transparent` : `${this.bgColor ?? this.color}, ${adjustColorBrightness((this.bgColor ?? this.color), 1.20)}`})`
      } else if (this.bgColor) {
        return this.bgColor;
      }

      return this.color;
    },
  },
  watch: {
    openId(val) {
      if (val !== this.item.id || val === "") {
        this.$refs['item'].style.height = '100%'
        this.$refs['item'].style.zIndex = 'initial'
      }
    },
  },
  mounted() {
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      window.addEventListener('resize', this.handler, { passive: true })
      this.$nextTick(this.handler)
    }
  },
  destroyed() {
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      window.removeEventListener('resize', this.handler)
    }
  },
  methods: {
    maskStyle(mask) {
      return buildMaskStyle(mask)
    },
    handler() {
      if (process.client) {
        this.textClamp = Boolean(this.$refs['text'].scrollHeight > 136) || this.currentText.length < this.item.fullText.length
      }
    },
    toggle() {
      if (process.client) {
        const itemHeight = this.$refs['item'].clientHeight

        if (this.manuallyOpen) {
          this.$emit('set-open-id', '')
        } else {
          this.$emit('set-open-id', this.item.id)
        }

        this.$nextTick(() => {
          if (window.innerWidth >= 640) {
            this.$refs['item'].style.height = this.manuallyOpen ? `${itemHeight}px` : '100%'
            this.$refs['item'].style.zIndex = this.manuallyOpen ? '10' : 'initial'
          }
        })
      }
    },
    openPopup() {
      if (this.item.image_type === 'icon') return
      this.$vfm.show({
        component: ImageModal,
        bind: {
          src: this.$addServerPath(this.imagePath),
          label: this.item.label || "Без названия",
          source: this.item.image_url
        },
        on: {
          'before-open': () => {
            this.isOpen = true
          },
          'closed': () => {
            this.isOpen = false
          }
        }
      })
    }
  }
}
